import { Directive, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[hinFormat]',
})
export class HinFormatDirective implements OnChanges {
    @Input() hin: string;
    @Output() onHinChange: EventEmitter<string> = new EventEmitter<string>();

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
      this.formatHin(changes.hin.currentValue);
    }

    private formatHin(value: string = ''): void {
      const hinParts: RegExpMatchArray = value.replace(/[^a-zA-Z0-9]/gi, '').match(/.{1,4}/g);
      const hin: string = hinParts && hinParts.length ? hinParts.join(' ').substr(0, 14) : '';

      this.onHinChange.emit(hin);
    }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/directives/hin-format.directive.ts